import { useState, useEffect } from 'react';
import axios from 'axios';
import { Prohibit, Spinner } from '@phosphor-icons/react';
import { Markdown } from '@/components/Markdown';
import { fmtDay } from '@/utils/dateFmt';
import { ERS_LABEL } from '@/config/legal';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CancellationPolicyPage() {
  const [policy, setPolicy] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/public/site-content`);
        setPolicy(data.cancellation_policy || '');
        setUpdatedAt(data.cancellation_policy_updated_at || '');
      } catch {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F4]" data-testid="cancellation-policy-page">
      <div className="max-w-2xl mx-auto px-4 py-12">
        <div className="flex items-center gap-2 text-[#2E3A33] mb-6">
          <Prohibit size={26} weight="duotone" style={{ color: '#657171' }} />
          <h1 className="font-heading font-semibold text-2xl">Política de Cancelamento</h1>
        </div>
        <div className="bg-white rounded-3xl border border-[#E8E3DB] p-6 sm:p-8">
          {!loading && updatedAt && policy.trim() && (
            <p className="text-[11px] text-[#A8AFA3] mb-4" data-testid="cancellation-updated-at">
              Última atualização: {fmtDay(updatedAt)}
            </p>
          )}
          {loading ? (
            <div className="text-center py-8"><Spinner size={28} className="mx-auto animate-spin text-[#5B8C7B]" /></div>
          ) : policy.trim() ? (
            <div className="prose-sm text-[#2E3A33]" data-testid="cancellation-content"><Markdown>{policy}</Markdown></div>
          ) : (
            <p className="text-sm text-[#7A8278]" data-testid="cancellation-empty">A Política de Cancelamento será disponibilizada em breve.</p>
          )}
        </div>
        <p className="text-center text-[11px] text-[#A8AFA3] mt-6">Ana Magalhães Pereira · Nutricionista (Cédula 2758N) · {ERS_LABEL} · ana@nutrianapereira.pt</p>
      </div>
    </div>
  );
}
